import { Checkbox, Table, TablePagination, styled } from '@mui/material';

export const StyledTable = styled(Table)(() => ({
  borderTopRightRadius: '8px',
  borderTopLeftRadius: '8px',
  border: '1px solid #E5E5E5',
  boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
  borderBottom: 0,
  overflow: 'hidden',
}));

export const StyledCheckbox = styled(Checkbox)(() => ({
  color: '#D0D5DD',
  '& .MuiSvgIcon-root': { fontSize: '20px' },
}));

export const StyledPagination = styled(TablePagination)(() => ({
  display: 'block',
  marginLeft: 'auto',
  color: '#344054',
  fontSize: '1.4rem',
  '& p': { fontSize: '1.4rem' },
  width: '100%',
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
  border: '1px solid #E5E5E5',
  borderTop: 0,
}));
